import { z } from 'zod';

export const transactionSchema = z.object({
  type: z.enum(['income', 'expense']),
  date: z.string().min(1, {message: 'errors:error.requiredDate'}),
  amount: z.number().min(1, {message: 'errors:error.minAmount'}),
  category: z.string().min(1, {message: 'errors:error.requiredCategory'}),
  // category: z.union([
  //   z.literal(""),
  //   z.enum(["給与", "副収入", "事業", "ボーナス", "一時収入","バイト"]),
  //   z.enum(["食費", "日用品", "光熱費", "居住費", "医療費", "娯楽費", "家電", "その他"]),
  // ]),
  // .refine((value) => value !== "", {
  //   message: "カテゴリは必須です。",
  // }),
  store: z.string().max(50, {message: 'errors:error.maxLengthStore'}).optional(),
  content: z.string().max(50, {message: 'errors:error.maxLengthContent'}).optional(),
});

export type validationSchema = z.infer<typeof transactionSchema>;